import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "font-weight-bold mb-4" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-white" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "Ausnahmen Logs")
], -1)
const _hoisted_5 = {
  key: 0,
  class: "card-body"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "alert alert-info" }, " Es sind noch keine Logs verfügbar. ", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "media-list media-list-bordered" }
const _hoisted_9 = { class: "media align-items-center" }
const _hoisted_10 = { class: "mr-3 align-self-center d-flex flex-column align-items-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("a", { class: "btn bg-transparent rounded-pill border-2 btn-icon border-primary text-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-store" })
], -1)
const _hoisted_12 = { class: "text-primary mt-2" }
const _hoisted_13 = { class: "media-body align-self-center d-flex flex-column" }
const _hoisted_14 = { class: "text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.headline), 1),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      (!_ctx.logs || _ctx.logs.length <= 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
        : _createCommentVNode("", true),
      _createElementVNode("ul", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logs, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: ""
          }, [
            _createElementVNode("a", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("small", _hoisted_12, _toDisplayString(_ctx.moment(item.createdAt).format("DD.MM.YYYY HH:mm")), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("span", null, " Schaltzeitänderung bei Anlage: " + _toDisplayString(item.anlage_bemerkung), 1),
                _createElementVNode("span", _hoisted_14, "durch Benutzer: " + _toDisplayString(item.userFirstName) + " " + _toDisplayString(item.userLastName), 1)
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}